namespace TabAurous.Common {
    export interface ProcessQIForm {
        QualityInspections: Production.QualityInspectionValuesEditor;
    }

    export class ProcessQIForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ProcessQI';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProcessQIForm.init)  {
                ProcessQIForm.init = true;

                var s = Serenity;
                var w0 = Production.QualityInspectionValuesEditor;

                Q.initFormType(ProcessQIForm, [
                    'QualityInspections', w0
                ]);
            }
        }
    }
}
